const freeze = function(e) {
	const modal = document.querySelector('modal');

	if (modal && !modal.contains(e.target)) {
		e.preventDefault();
	} else if (modal) {
		e.stopPropagation();
	}
};

const attach = (target, event) => target.addEventListener(event, freeze);
const unattach = (target, event) => target.removeEventListener(event, freeze);

const eventsToAttach = [
	'touchmove',
	'touchstart',
	'mousedown',
	'click',
	'pointermove',
	'mousewheel',
	'wheel',
	'scroll'
];

const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const disableScroll = () => {
	const html = document.querySelector('html');
	html.style.overflow = 'hidden';
	document.body.style.overflow = 'hidden';

	if (IS_IOS) {
		document.body.style.position = 'fixed';
		document.body.style.width = '100%';
		document.body.style.height = '100%';
	}

	// Only accept touchmove from fixed-element
	eventsToAttach.forEach(event => attach(document, event));
	eventsToAttach.forEach(event => attach(html, event));
};

export const enableScroll = () => {
	const html = document.querySelector('html');
	html.style.overflow = '';
	document.body.style.overflow = '';

	if (IS_IOS) {
		document.body.style.position = '';
		document.body.style.width = '';
		document.body.style.height = '';
	}

	eventsToAttach.forEach(event => unattach(document, event));
	eventsToAttach.forEach(event => unattach(html, event));
};



// WEBPACK FOOTER //
// ./src/scrollPrevention.js